export default function ErroData() {
    return (
        <div className="flex flex-col w-screen h-screen gap-5 text-center justify-center items-center">
            <p className="text-[35px] md:text-[40px] lg:text-[45px] xl:text-[50px] text-red-500 font-bold">Erro ao carregar dados</p>
            <p className="text-[25px] font-medium">Tente novamente, recarregando a página</p>
        </div>
    )
}